import { createStyles, Theme } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    content: {
      height: '100%',
      zIndex: 1,
    },
    block: {
      padding: spacing(6),
      marginBottom: spacing(8),
      backgroundColor: colors.grey.body,
      borderRadius: 8,
    },
    blockTitle: {
      fontSize: 16,
      fontWeight: 600,
      display: 'inline-block',
      marginBottom: spacing(4),
    },
    row: {
      marginBottom: spacing(6),
    },
    fullRowElement: {
      width: '100%',
    },
    label: {
      display: 'inline-block',
      marginBottom: spacing(2),
      fontWeight: 500,
    },
    matchesFooter: {
      padding: spacing(14, 3, 2),
    },
    selectElement: {
      padding: spacing(6.5, 4),
      marginBottom: spacing(2),
      backgroundColor: colors.white.lightest,
      borderRadius: 6,
      justifyContent: 'space-between',
    },
    selectElementInfo: {
      gap: 8,
    },
    selectElementName: {
      fontWeight: 500,
    },
    selectElementAddress: {
      color: '#7E8899', //TODO change after creating new palette
    },
    alertNotification: {
      border: '1px solid #FEB872', //TODO change after creating new palette
      backgroundColor: '#FFF5EB', //TODO change after creating new palette
      marginBottom: spacing(8),
      borderRadius: 6,
      color: '#B54708',
      fontSize: 3.5,
    },
    text: {
      fontWeight: 400,
    },
    alertNotificationTitle: {
      lineHeight: '20px',
      fontSize: 14,
      marginBottom: spacing(1),
    },
    alertNotificationContent: {
      padding: spacing(3, 4),
    },
    icon: {
      fontSize: 18,
      verticalAlign: 'top',
    },
  });
